import { useDataApi } from '../../hooks/useDataApi/useDataApi';
import { RequestData, ResponseData } from '../../hooks/useDataApi/requestData';
import { useCallback } from 'react';
import { useBuddiContext } from '../../context/buddiContext/buddiContext';

interface DiagnosticsDto {
  createdTimeStamp: string;
  id: string;
  imodelId: string;
  runId: string;
  taskId: string;
  sasUri: string;
}

interface Diagnostics {
  createdAt: string;
  id: string;
  iModelId: string;
  runId: string;
  taskId: string;
  SASUri: string;
} 

export const useBadgers = (
  iModelId: string,
  runId: string,
  taskId: string
): [
  Diagnostics,
  boolean,
  any,
  () => Promise<ResponseData<Diagnostics> | null>
] => {
  const { buddiUrls } = useBuddiContext();

  const useDataSettings = {
    initialData: {} as Diagnostics,
    initialIsLoading: false,
  };
  const [result, isLoading, error, fetchData] =
    useDataApi<any>(useDataSettings);

  const baseUrl = `${buddiUrls.synchronizationApimUrl}/reports?imodelId=${iModelId}&runId=${runId}&taskId=${taskId}`; 

  const getDiagnostics = useCallback(
    async () => {
      const url = baseUrl;
      const requestData: RequestData<any> = {
        url: `${url}`,
        map: x => x,
        method: 'GET',
      };

      const response = await fetchData(requestData);

      if (!response.ok || response.data.length === 0) {
        return null;
      }

      if (response.data.reports.length === 0) {
        return null;
      }

      const report: DiagnosticsDto = response.data.reports[0];

      return {
        ...response,
        data: mapDiagnosticsDtoToDiagnostics(report)
      }
    },
    [baseUrl, fetchData]
  ); 

  return [result, isLoading, error, getDiagnostics];
};

const mapDiagnosticsDtoToDiagnostics = (
  response: DiagnosticsDto 
): Diagnostics => {
  return {
    createdAt: response.createdTimeStamp,
    id: response.id,
    iModelId: response.imodelId,
    runId: response.runId,
    taskId: response.taskId,
    SASUri: response.sasUri,
  }
};
